import React,{useState} from 'react'

export default function Form(props) {
    const [name, setName] = useState("")

    function onNameChange(event){
        setName(event.target.value)
    }

    function onSubmit(event){
        event.preventDefault();
        props.onNameSubmit(name)
    }

    return (
        <>
            <form className="form-inline mt-3 ml-3" style={{width:"480px"}} onSubmit={onSubmit}>
                <input className="form-control mb-2" onChange={onNameChange} type="text" placeholder="bulbasaur"></input>
                <input className="btn btn-primary ml-2 mb-2" type="submit" value="Submit" />
            </form>
        </>
    )
}

